/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { injectable, decorate, inject } from 'inversify';
import { AxiosRequestConfig, AxiosResponse, Axios } from 'axios';
import { LOGIN_URL, BASE_URL } from '@/common/constant/index';
import { Message } from 'element-ui';
import { KeyObject } from '@/common/interface';
import StorageService from './storage.service';
import uni from '@/libs/uni_webview/uni.webview.1.5.4.js';
import UserService from './user.service';
import { Toast } from 'mint-ui';

decorate(injectable(), Axios);

@injectable()
export default class HttpClient extends Axios {
  @inject(StorageService)
  protected storage!: StorageService;

  @inject(UserService)
  protected userService!: UserService;

  constructor() {
    super({
      baseURL: BASE_URL,
    });

    this.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        const { url, data } = config;

        if (data && data.extData) {
          const { showErrorToast, authorization } = data.extData;
          this.showErrorToast =
            showErrorToast === undefined ? true : showErrorToast;
          this.authorization =
            authorization === undefined ? true : authorization;
        } else {
          this.showErrorToast = true;
          this.authorization = true;
        }
        config.headers = {
          'Content-Type': 'application/json;charset=UTF-8',
        };

        if (url && !LOGIN_URL.includes(url) && this.authorization) {
          console.log('1');
          if (!config.headers) {
            config.headers = {
              'Content-Type': 'application/json;charset=UTF-8',
            };
          }

          (config.headers as KeyObject<any>).AUTHORIZATION =
            this.userService.currentUser()?.token;
        } else {
          console.log('3');

          config.headers = {
            'Content-Type': 'application/json;charset=UTF-8',
          };
        }

        if (data && data.extData) {
          delete data.extData;
        }

        if (config.data) {
          if (config.data.loadingEl) {
            delete config.data.loadingEl;
          }
          config.data = JSON.stringify(config.data);
        }
        config.paramsSerializer = undefined;
        return config;
      },
      (error) => {
        // 取消或者其他异常
        Promise.reject(error);
      },
    );

    this.interceptors.response.use(
      (response) => {
        if (response.status === 200 && response.data) {
          return this.processData(response);
        } else if (response.status === 401) {
          console.log('401');
          this.login();
          this.storage.remove('user');
          this.storage.remove('permission');
          const url = `/login/${localStorage.getItem('brandcode') as string}`
          window.location.hash = url;
          return Promise.reject(new Error('登录异常'));
        } else {
          try {
            const errData =
              typeof response.data === 'string'
                ? JSON.parse(response.data)
                : response.data;
            const reason = errData.error;
            // Message.error(reason || '请求错误');
            Toast({
              message: reason || '请求错误',
              type: 'fail',
            });
            return Promise.reject(new Error(reason || '请求错误'));
          } catch (error) {
            return Promise.reject(new Error(response.data));
          }
        }
      },
      (error) => {
        // 取消或者其他异常
        this.processError(error);
      },
    );
  }

  /** 是否设置token请求头 */
  protected authorization = true;

  /** 是否toast提示请求错误 */
  protected showErrorToast = true;

  /** 请求成功默认回调 */
  private processData(res: AxiosResponse<any>) {
    const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
    const status = data.status || data.code;
    switch (status) {
      case 0:
        return Promise.resolve(data.data);
      default:
        return Promise.reject(data);
    }
  }

  /** 请求失败默认回调 */
  private processError(err: any) {
    console.log(err, 'err');
    return Promise.reject(err);
  }

  private login() {
    uni.postMessage({ data: { type: 'login' } });
  }
}
